<template>
  <div class="form-runtime-outside-chain" v-if="getSettingSuccess"
       :style="{backgroundImage: `url(${formSettings.background.coverPicIndex > 5 ? formSettings.background.uploadImg:defaultBackgroundImg})`}">
    <div class="form-background" v-if="!formSettings.background.uploadImg && !defaultBackgroundImg" :style="{backgroundColor:`${defaultBackgroundColor}`}"></div>
    <el-container class="form-runtime" v-show="!isAfterSubmit && formStatus === 'normal'" v-loading="formLoading">
      <el-main>
        <div class="form-runtime-header">
          <span class="form-runtime-header-name" v-if="formSettings.title">{{formSettings.title}}</span>
          <img class="form-runtime-header-logo" :src="formSettings.logo">
        </div>
        <rc-form
          ref="form"
          v-if="definition.form"
          :value="dataService.data"
          :component="definition.form"/>
      </el-main>
      <el-footer class="form-footer">
        <div class="buttons runtime-buttons">
          <el-button ref="formButtons" type="primary" :loading="loading" @click="click">
            {{formSettings.button}}
          </el-button>
        </div>
      </el-footer>
      <custom-dialog :data="customDialog"></custom-dialog>
    </el-container>
    <!-- 二维码图标 -->
    <el-popover
      popper-class="qr-code-popper"
      class="qr-code"
      placement="bottom-start"
      trigger="click">
      <div class="qr-code-icon" slot="reference"></div>
      <img class="form-qr-code" :src="QrCode">
    </el-popover>
    <!-- 提交成功块, 提交完成后 || 表单状态为只能提交一次的表单 || 表单状态为当天已提交  -->
    <div class="form-runtime-outside-model" v-if="definition.form && (isAfterSubmit || formStatus === 'not_allowed' || formStatus === 'not_allowed_today')">
      <i class="el-icon-success"></i>
      <p class="form-name">{{definition.form.name}}</p>
      <p v-if="formSettings.useType !== '每天一次'">提交成功</p>
      <p v-else>提交成功！明天还可以继续提交</p>
      <div class="form-another-button" v-if="formSettings.useType === '无限制'" @click="continueCreate">
        再填写一份
        <i class="el-icon-loading" v-show="continueCreateLoading"></i>
      </div>
    </div>
    <span class="tenant-name">由{{applicationName}}创建</span>
  </div>
  <!-- 表单无法访问块-->
  <div v-else-if="formStatus === 'not_exist'" class="form-runtime-outside-noform">
    <div class="noform-background"></div>
    <div class="noform-body">
      <i class="el-icon-error"></i>
      <span>您访问的表单不存在</span>
    </div>
  </div>
</template>

<script>
import sdk from 'redcatSdk'
import CookieOperation from '@/plugins/cookie'
import {calculationMixin, interactionMixin} from './components/mixins'
import RcForm from './components/rc-form.vue'
import Definition from '@/store/form/definition'
import DataService from '../../../store/form-runtime/dataService.js'
import Schema from '@/store/form/schema.js'
import CodeService, { EventBus } from '@/store/form-runtime/codeService'

let dataService = new DataService()

export default {
  name: 'FormRuntimeOutsideChain',
  props: ['id', 'depId', 'isDialog'],
  mixins: [calculationMixin, interactionMixin],
  provide () {
    return {
      dataService,
      eventBus: this.eventBus,
      initState: {},
      initCount: this.initCount
    }
  },
  data () {
    return {
      eventBus: new EventBus(),
      initStateObj: {state: false},
      definition: {},
      dataService,
      customDialog: {
        dialog: {
          visible: false
        }
      },
      loading: false,
      initCount: {value: 0},
      isAfterSubmit: false,
      getSettingSuccess: false,
      formLoading: true,
      continueCreateLoading: false,
      applicationName: '',
      formStatus: 'normal',
      formSettings: {},
      QrCode: '',
      themeColorList: [
        {color: '#E64F27'},
        {color: '#EB933E'},
        {color: '#5263E7'},
        {color: '#687F2A'},
        {color: '#9B7DF0'},
        {color: '#8DD1ED'},
        {color: '#835C52'}
      ],
      coverPicList: [
        require('./components/assets/OC_bg01.png'),
        require('./components/assets/OC_bg02.png'),
        require('./components/assets/OC_bg03.png'),
        require('./components/assets/OC_bg04.png'),
        require('./components/assets/OC_bg05.png'),
        require('./components/assets/OC_bg06.png')
      ]
    }
  },
  components: {
    RcForm,
    customDialog: () => {
      return Promise.resolve(sdk.components.CustomDialog)
    }
  },
  async created () {
    // 存储浏览器信息到cookie给后端使用
    CookieOperation.set('user-agent', window.btoa(navigator.userAgent))
    // 获取当前租户信息
    await this.getApplicationSettings()
    // 判断是否移动设备, 是则跳转到移动端
    await this.$axios.get('/form-api/publicPublish/runtime/currentSystemUrl').then(res => {
      this.systemType = res.data.system
      if (typeof window.orientation !== 'undefined' || /Mobi|Android/i.test(navigator.userAgent)) {
        location.href = `${res.data.mobileDomain}/mobile/tt/${this.id}/${CookieOperation.get('tenantId')}/${this.applicationName}`
      }
    })
    // 判断当前表单是否可用，不可用则直接给‘表单不存在页’
    await this.verificationForm()
    await this.getDownloadURL()
    // 获取外链配置信息
    await this.getFormSettings()
    await this.initCreate()
  },

  mounted () {
    this.eventBus.$emit('form.afterInit')
  },
  methods: {
    // 校验表单状态
    verificationForm () {
      return this.$axios.post(`/form-api/publicPublish/runtime/verification/${this.id}`).then(res => {
        // code：0 成功 ， 1失败； 根据失败的信息作区分
        if (res.data.code === 1) {
          // 根据失败状态对不同的表单信息做区分
          if (res.data.message.includes('表单不存在')) {
            // 不存在时不发送后面的请求，直接抛出错误；否则展示提交成功页面，并继续请求
            this.formStatus = 'not_exist'
            throw new Error('form code 1: not_exist')
          } else if (res.data.message.includes('明天还可以继续提交')) {
            this.formStatus = 'not_allowed_today'
          } else if (res.data.message.includes('只能提交一次')) {
            this.formStatus = 'not_allowed'
          }
        }
      })
    },
    // 获取当前租户信息
    getApplicationSettings () {
      let domain = document.domain
      if (domain === 'localhost') {
        domain = CookieOperation.get('domain') || console.warn('本地开发设置 cookie.domain') || '2405.rc-dev-test.ywsoftware.cn'
      }
      return this.$axios.get('/system-api/application/getSettingByDomain', { params: { domain }, timeout: 30000, disableInterceptors: true })
        .then(res => {
          let data = res.data
          if (!(data && data.data)) {
            return Promise.reject(new Error('获取租户信息失败'))
          }
          CookieOperation.set('tenantId', data.data.id)
          this.applicationName = data.data.applicationName
        })
    },
    // 获取外链的下载地址
    getDownloadURL () {
      return this.$axios.get('/shared-api/files/oss').then(res => {
        sessionStorage.setItem('accessKeyId', res.data.accessId)
        sessionStorage.setItem('policy', res.data.policy)
        sessionStorage.setItem('signature', res.data.signature)
        sessionStorage.setItem('ossDownloadUrl', res.data.host)
      })
    },
    // 获取当前表单定义id,背景图片,二维码等设置
    getFormSettings () {
      return this.$axios.post(`/form-api/publicPublish/runtime/defines/${this.id}`).then(res => {
        if (res.status === 200) {
          this.formSettings = res.data
          this.formSettings.background = res.data.background && JSON.parse(res.data.background)
          // 如果存在背景图片，拼接上预览地址
          if (this.formSettings.background.uploadImg) {
            this.formSettings.background.uploadImg = sessionStorage.getItem('ossDownloadUrl') + this.formSettings.background.uploadImg
          }
          this.QrCode = this.systemType === 'test' ? this.formSettings.testQrCode : this.formSettings.sysQrCode
          // logo地址拼接上预览地址
          this.formSettings.logo = res.data.logo && sessionStorage.getItem('ossDownloadUrl') + res.data.logo
          this.getSettingSuccess = true
        }
      })
    },

    async initCreate () {
      dataService = new DataService()
      this._provided.dataService = this.dataService
      this._provided.initState = this.initStateObj
      await this.loadForm()
      this.$refs.form && this.$refs.form.sortComponent()
      await this.buildData()
      this._provided.initState.type = 'form'
      const formService = {
        openCustomDialog: (data) => {
          this.customDialog.dialog = data
        }
      }
      const codeService = new CodeService({ eventBus: this.eventBus, form: { define: this.definition, dataService: this.dataService }, formService, el: this })
      codeService.load()
      await this.eventBus.$emit('form.beforeInit')
      this.$nextTick(() => {
        this.init()
      })
    },
    loadForm () {
      return this.$axios.post('/form-api/publicPublish/runtime/formDefines/' + this.id)
        .then(res => {
          this.definition = new Definition(res.data)
          this.dataService.schema = new Schema()
          this.dataService.schema.load(res.data.form.schema)
          this.formLoading = false
          // 如果表单当天或已经无法提交，则获取完表单定义之后不再加载
          if (this.formStatus !== 'normal') {
            throw new Error('form code 1: not_allowed')
          }
        }).catch(() => {
          this.formLoading = false
        })
    },
    buildData () {
      this.dataService.data = this.dataService.buildModel(this.definition.form.archive.tableId)
    },
    init () {
      return this.initComponents()
    },
    async initComponents () {
      if (this.$refs.form) {
        await this.$refs.form.init()
      }
      this.initStateObj.state = true
      this.initInteraction()
    },
    validate () {
      return this.$refs.form.validate()
    },
    click () {
      this.loading = true
      this.formVerification()
        .then(() => this.submit())
        .catch(() => {
          this.loading = false
        })
    },
    // 二次校验表单是否重复提交
    async formVerification () {
      if (this.formSettings.useType === '无限制') {
        return Promise.resolve()
      } else {
        await this.$axios.post(`/form-api/publicPublish/runtime/verification/${this.id}`).then(res => {
          if (res.data.code === 1) {
            this.$message.error('当前表单无法重复提交')
            throw new Error('重复提交')
          }
        })
      }
    },
    beforeSubmit (params) {
      return this.eventBus.$emit('form.beforeSubmit', params)
    },

    submit (button, type) {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          this.validate()
            .then(() => {
              // 处理数据, 将表格中的空行去去掉
              this.dataService.buildSubmitData(this.definition.form)
              this.loading = true
            })
            .then(async () => {
              // todo: 存储浏览器，设备，系统信息
              this.dataService.data.link = this.id // 存储外链id后端使用
              if (this.formSettings.system) {
                this.dataService.data[this.formSettings.system] = this.getSystemType()
              }
              if (this.formSettings.browser) {
                this.dataService.data[this.formSettings.browser] = this.judgeBrowser()
              }
              if (this.formSettings.equipment) {
                this.dataService.data[this.formSettings.equipment] = this.getEquipment()
              }
              return this.$axios.post(`/form-api/publicPublish/runtime/${this.definition.form.id}/saveData`, this.dataService.data)
            })
            .then(() => {
              this.isAfterSubmit = true
              this.loading = false
              this.initStateObj.state = false
              resolve()
            })
            .catch(() => {
              this.loading = false
              this.$nextTick(() => {
                let isError = document.querySelectorAll('.is-error')
                if (isError && isError.length !== 0) {
                  // 表格内部不知道什么时候校验表单，所以这里加了个eventBus，用来控制表单必填样式
                  this.eventBus.$emit('form.afterValidate')
                  if (isError[0].querySelector('input')) {
                    isError[0].querySelector('input').focus()
                  } else if (isError[0].querySelector('textarea')) {
                    isError[0].querySelector('textarea').focus()
                  }
                }
              })
              reject(new Error('表单提交失败'))
            })
        })
      })
    },
    buildSubmitData () {
      let data = this.dataService.data
      Object.keys(data).forEach(key => {
        // 如果值是数组类型的, 说明是一个表格或者其他一对多的东西
        if (data[key] instanceof Array) {
          // 临时变量, 下面会使用到
          let tempData = data[key][0]
          // 过滤出数组中所有值都是空的东西
          data[key] = data[key].filter(m => {
            let flag = false
            for (let index in m) {
              // fixme: 这个地方为了方便直接只判断了 UUID 的值是否为空, 以后如果有其他的情况, 请注意修复
              if (index.length > 32 && m[index] !== '') {
                flag = true
                break
              }
            }
            return flag
          })
          if (!data[key] || data[key].length === 0) {
            // 判断, 假如表格中没有填写任何东西, 但是表格中的控件存在必填属性, 则在表格中增加一个一类数据, 给表单校验使用, 赋值内容为上面克隆出来的临时变量
            let table = this.definition.form.find(m => m.archive.relationId === key) || this.definition.form.find(m => m.archive.tableId === key)
            if (table && table.children) {
              let children = table.children
              for (let index in children) {
                if (children[index].properties.required) {
                  break
                }
              }
              table.children.forEach(children => {
                if (children.properties.required) {
                  data[key].push(tempData)
                }
              })
            } else {
              throw new Error('表单错误')
            }
          }
        }
      })
    },
    // 再填写一份
    async continueCreate () {
      if (this.continueCreateLoading) {
        return false
      }
      this.continueCreateLoading = true
      try {
        await this.initCreate()
        this.initCount.value++
        this.isAfterSubmit = false
        this.continueCreateLoading = false
      } catch (e) {
        this.continueCreateLoading = false
      }
    },
    getSystemType () {
      return /macintosh|mac os x/i.test(navigator.userAgent) ? 'Mac' : /windows|win32/i.test(navigator.userAgent) ? 'Windows' : ''
    },
    getEquipment () {
      let u = navigator.userAgent
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        return 'Android'
      } else if (u.indexOf('iPhone') > -1) {
        return 'iPhone'
      } else if (u.indexOf('Windows Phone') > -1) {
        return 'Windows Phone'
      } else {
        return 'PC'
      }
    },
    judgeBrowser () {
      let u = navigator.userAgent
      // 先判断是否为360
      if (this.judge360('type', 'application/vnd.chromium.remoting-viewer')) {
        return '360浏览器'
      }
      if (u.indexOf('MSIE') >= 0) {
        return 'IE'
      } else if (u.indexOf('Firefox') >= 0) {
        return 'Firefox'
      } else if (u.indexOf('Chrome') >= 0) {
        return 'Chrome'
      } else if (u.indexOf('Opera') >= 0) {
        return 'Opera'
      } else if (u.indexOf('Safari') >= 0) {
        return 'Safari'
      } else if (u.indexOf('Netscape') >= 0) {
        return 'Netscape'
      }
    },
    // 360 navigator.userAgent 和谷歌一模一样。
    judge360 (option, value) {
      let mimeTypes = navigator.mimeTypes
      for (let mt in mimeTypes) {
        if (mimeTypes[mt][option] === value) {
          return true
        }
      }
      return false
    }
  },
  computed: {
    // 默认背景图片
    defaultBackgroundImg () {
      if (this.formSettings.background.coverPicIndex || this.formSettings.background.coverPicIndex === 0) {
        return this.coverPicList[this.formSettings.background.coverPicIndex]
      }
    },
    // 默认背景颜色
    defaultBackgroundColor () {
      if (this.formSettings.background.themeColorIndex || this.formSettings.background.themeColorIndex === 0) {
        return this.themeColorList[this.formSettings.background.themeColorIndex].color
      } else {
        return this.themeColorList[5].color
      }
    }
  }
}
</script>

<style lang="scss">
  .form-runtime-outside-chain{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 6% 15% 0;
    box-sizing: border-box;
    background: no-repeat top/100% 36%;
    .form-background{
      width: 100%;
      height: 36%;
      position: fixed;
      top: 0;
    }
    .form-runtime {
      flex: 0 1 88%;
      width: 100%;
      height: 88%;
      background: #fff;
      box-shadow:0px 3px 7px 0px rgba(0, 0, 0, 0.1);
      margin-bottom: 14px;
      z-index: 999;

      ::-webkit-input-placeholder { /* WebKit browsers */
        color: #232323;
      }
      :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: #232323;
      }
      ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #232323;
      }
      :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: #232323;
      }
      .el-main {
        height: 100%;
        .el-form-item__content {
          height: 100%;
          font-size: 12px;
        }
      }
      main.el-main{
        padding: 20px 40px;
        .form-layout-run .layout-form{
          padding-left: 0;
        }
      }
      .form-runtime-header{
        height: 20%;
        min-height: 60px;
        padding-top: 20px;
        border-bottom: 1px solid #EBEBEB;
        margin-bottom: 32px;
        .form-runtime-header-name{
          font-size: 18px;
          color: #29282E;
        }
        .form-runtime-header-logo{
          float: right;
          max-height: 51px;
        }
      }
      .el-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        .runtime-buttons{

          >button{
            width: 100px;
            position: relative;
            .el-icon-loading {
              position: absolute;
              right: 0;
              top: 7px;
            }
          }
        }
      }
      .form-footer {
        position: relative;
        border-top: 1px solid #EBEBEB;
        margin: 10px 40px 0;
        .continue-create {
          height: 20px;
          position: absolute;
          left: 32px;
          top: 23px;
          .is-checked {
            .el-checkbox__label {
              color: #606266;
            }
            .el-checkbox__inner {
              &::after {
                display: none;
              }
              width: 14px;
              height: 16px;
              display: inline-block;
              background: url('../componentAttr/assets/select.png') no-repeat;
              background-size: 14px;
              border: none;
            }
          }
          .is-focus {
            .el-checkbox__inner {
              border-color: #DCDFE6;
            }
          }
        }
      }
      .el-input.is-disabled .el-input__inner {
        background: #F2F3F5;;
        border:1px solid #c2c3c4;
      }
      .rc-container .container-form {
        .rc-rich {
          height: 100%;
          .el-form-item {
            height: 100%;
          }
          .el-form-item__content {
            height: 100%;
          }
        }
      }
    }
    .qr-code{
      width: 40px;
      height: 40px;
      position: absolute;
      left: 86%;
      overflow: hidden;
      border-radius: 3px;
      cursor: pointer;
      .qr-code-icon{
        width: 40px;
        height: 40px;
        box-shadow:0px 3px 7px 0px rgba(0, 0, 0, 0.19);
        border-radius:3px;
        border: 1px solid #ebebeb;
        background: url("./components/assets/icon-qrCode.png") no-repeat center/100% 100%;
        &:hover{
          background: url("./components/assets/icon-qrCode-hover.png")
        }
      }
    }
    .form-runtime-outside-model{
      @extend .form-runtime;
      position: relative;
      min-height: 400px;
      text-align: center;
      padding-top: 114px;
      .el-icon-success{
        font-size: 65px;
        color: #54ABF1;
        margin-bottom: 44px;
      }
      p.form-name{
        font-size: 16px;
        margin-bottom: 20px;
      }
      p{
        color: #29282E;
        font-size: 14px;
      }
      .form-another-button {
        position: absolute;
        bottom: 50px;
        left: 50%;
        color: #54ABF1;
        font-size: 14px;
        margin-left: -35px;
        cursor: pointer;
      }
    }
    .tenant-name{
      color:#29282E;
      align-self: flex-start;
    }
  }
  .form-runtime-outside-noform{
    @extend .form-runtime-outside-chain;
    background-color: #FFFFFF;
    .noform-background{
      width: 100%;
      height: 36%;
      position: fixed;
      top: 0;
      background: #6EB8F5 no-repeat top/100% 100%;
    }
    .noform-body{
      display: flex;
      flex-direction: column;
      flex: 0 1 70%;
      width: 100%;
      height: 70%;
      align-items: center;
      padding-top: 114px;
      background: #fff;
      box-shadow:0px 3px 7px 0px rgba(0, 0, 0, 0.1);
      z-index: 999;
      .el-icon-error{
        font-size: 65px;
        color: #F54133;
        margin-bottom: 44px;
      }
      span{
        font-size: 16px;
      }
    }
  }
  .el-message.el-message--info.is-center.without-execute-dialog{
    position: fixed;
    left: calc(50% + 100px);
    top: 40%;
    background-color: #29282E;
    >p{
      color: #FFFFFF;
    }
    >i{
      display: none;
    }
  }
  .el-popover .form-qr-code{
    width: 137px;
    height: 137px;
  }
  .qr-code-popper{
    padding: 0;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/form-runtime-outside-chain.vue